module.exports = "static/assets/7c410b6c3cd2a9ee41505c5c6951bbf6.png";